<template>
	<div style="width: 100%" class="user-page">
		<v-subheader>
			{{ $t('user.users') }} > {{ $t('user.user') }} #{{ $route.params.userId }}
		</v-subheader>
		<v-container grid-list-lg>
			<v-card>
				<h3 class="caption-block">
					{{ $t('user.header') }}
				</h3>
				<v-card-title primary-title>
					<v-layout>
						<v-flex md3>
							<Avatar :avatar="user.avatar" :upload-path="uploadPath" @delete="deleteAvatar"
								@setAvatar="setAvatar" />
							<v-switch :label="status" v-model="user.enabled" />
						</v-flex>
						<v-flex md9>
							<v-layout row wrap>
								<v-flex xs12 sm6 md4>
									<v-text-field :label="$t('common.name')" v-model="user.name" />
								</v-flex>

								<v-flex xs12 sm6 md4>
									<v-text-field :label="$t('login.email')" v-model="user.email"
										:error-messages="emailError" />
								</v-flex>

								<v-flex xs12 sm6 md4>
									<v-text-field :label="$t('user.passport')" v-model="user.passport" />
								</v-flex>

								<v-flex xs12 sm6 md4>
									<Datepicker :label="$t('workers.birth_date')" v-model="user.birth_date" />
								</v-flex>

								<v-flex xs12 sm6 md4>
									<v-text-field :label="$t('user.created_at')" :readonly="true"
										v-model="user.created_at" />
								</v-flex>

								<v-flex xs12 sm6 md4>
									<v-text-field :readonly="true" :label="$t('user.updated_at')"
										v-model="user.updated_at" />
								</v-flex>
								<v-combobox v-model="$store.state.users.userDetail.payment_categories"
									:label="$t('payment_category.caption')" multiple chips clearable></v-combobox>

							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout fluid>
						<v-flex>
							<h3>
								{{ $t('workers.roles') }}
							</h3>
							<v-radio-group v-model="user.roles && user.roles[0]" row>
								<v-radio v-for="(item, index) in roles" :key="index" :label="item.name"
									:value="item.value"></v-radio>
							</v-radio-group>
						</v-flex>
					</v-layout>
					<v-layout row justify-center class="save-button">
						<v-tooltip top>
							<v-btn color="green lighten-1" class="white--text" slot="activator" @click="save">
								<v-icon>save</v-icon>
								<span style="padding-left: 5px">{{ $t('common.save') }}</span>
							</v-btn>
							<span>
								{{ $t('user.save_user') }}
							</span>
						</v-tooltip>
					</v-layout>
				</v-card-title>
			</v-card>
			<v-card class="address-block">
				<h3 class="caption-block">
					{{ $t('address.address') }}
				</h3>
				<v-card-title primary-title>
					<address-group :main-label="$t('address.user_home_address')"
						:main-address="user.user_home_address && user.user_home_address[0]" :onlyMain="true"
						@update="updateAddressWithNotify" @createOne="createAddressOne" @delete="deleteAddressWithNotify" />
				</v-card-title>
			</v-card>
			<v-layout row justify-center class="save-button">
				<v-flex>
					<password-changer />
				</v-flex>
				<v-flex>
					<v-btn color="blue" dark :to="'/personal-finance/user/' + $route.params.userId">
						{{ $t('personal_finance.show_personal_finance') }}
					</v-btn>
				</v-flex>
			</v-layout>

		</v-container>
		<Loader v-if="isLoading" />
	</div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import Datepicker from '../../components/DatePicker'
import Loader from '../../components/Loader'
import PasswordChanger from './PasswordChanger'
import Avatar from '../../components/Avatar'
import AddressGroup from '../../components/address-group/AddressGroup'
import { notify } from '../../utils/notifications'

export default {
	components: {
		Datepicker,
		Loader,
		PasswordChanger,
		Avatar,
		AddressGroup
	},
	data: vm => ({
		roles: [
			{ name: vm.$t('roles.admin'), value: 'admin' },
			{ name: vm.$t('roles.manager'), value: 'manager' },
			{ name: vm.$t('roles.can_prepay'), value: 'canPrepay' },
		],
		switch1: true,
		menu2: false,
		date: null
	}),
	created() {
		this.$store.dispatch('users/fetchOne')
	},
	computed: {
		...mapState({
			user: ({ users }) => users.userDetail,
			isLoading: ({ users }) => users.isLoadingDetail,
			emailError: ({ users }) => users.emailError
		}),
		status() {
			return this.$t(`common.${this.user.enabled ? 'enabled' : 'disabled'}`)
		},
		uploadPath() {
			return `/users/${this.$route.params.userId}/upload-avatar`
		}
	},
	methods: {
		...mapActions({
			createAddress: 'users/createAddress',
			updateAddress: 'users/updateAddress',
			deleteAddress: 'users/deleteAddress'
		}),
		...mapMutations({
			setAvatarUsers: 'users/setAvatar',
			setAvatarAuth: 'auth/setAvatar'
		}),
		setAvatar(filename) {
			this.setAvatarUsers(filename)
			this.setAvatarAuth(filename)
		},
		save() {
			this.$store.dispatch('users/saveUser')
				.then(() => {
					if (!this.emailError) {
						this.$notify({
							...notify,
							text: this.$t('notifications.saved', {
								type: this.$t('user.user')
							})
						})
					}
				})
		},
		deleteAvatar() {
			this.$store.dispatch('users/deleteAvatar')
			this.setAvatarAuth(null)
		},
		getAvatar: name => Vue.http.options.root + '/files/' + name,
		updateAddressWithNotify(data) {
			this.updateAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('address.address'),
					})
				})
			})
		},
		createAddressOne(data) {
			this.createAddress({
				...data,
				addressable_type: 'user_home_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		deleteAddressWithNotify(data) {
			this.deleteAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('common.deleted'),
					})
				})
			})
		}
	}
}
</script>

<style scoped>
.center {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.user-page .caption-block {
	font-size: 18px;
	text-align: center;
	padding-top: 10px;
}

.user-page .address-block {
	margin-top: 10px;
}
</style>
